module.exports = "https://static.wmbcdn.com/uniweb/images/f35b056763dd1fda8082c5c8f906f997.svg";